import React, { createContext, useContext } from "react";

export interface LabelsContextData {
  labels: Record<string, string>;
  richTextLabels: Record<string, string>;
}

export const LabelsContext = createContext<LabelsContextData>({ labels: {}, richTextLabels: {} });

export function mapLabelsByKey<T>(
  labelNodes: {
    node_locale: string;
    internalName: string | null;
    value: T;
  }[],
  getValue: (value: T) => string
) {
  return labelNodes
    .filter((label) => !!label.internalName)
    .reduce(
      (acc, label) => ({
        ...acc,
        [label.internalName!]: getValue(label.value),
      }),
      {}
    );
}

export function useLabels() {
  const labelsContext = useContext(LabelsContext);
  if (!labelsContext) throw new Error("useLabels must be invoked under LabelsProvider");
  return labelsContext;
}
